export const siteVisitStatusEnum = {
  2: {
    className: "prePlanningPhase",
    fill: "var(--Primary-Blueberry-700, #325899)",
    text: "Pre-planning phase",
  },
  3: {
    className: "planning",
    fill: "#964B00",
    text: "Planning",
  },
  4: {
    className: "dataCollection",
    fill: "#3B81FE",
    text: "Data collection",
  },
  5: {
    className: "postDataCollection",
    fill: "#045B46",
    text: "Post data collection/Data check",
  },
  6: {
    className: "visitCompleted",
    fill: "#0F7507",
    text: "Visit completed",
  },
  default: {
    className: "noStatus",
    fill: "rgba(172, 12, 12, 0.777)",
    text: "No Status",
  },
};

export const getSiteVisitStatus = (text) =>
  siteVisitStatusEnum[text] || siteVisitStatusEnum.default;

// Resolve a status STRING (e.g. from the AI search: "PrePlanningPhase",
// "DataCollection", "NoStatus") to the same {text, fill, className} the tables
// use, so search results colour-match the rest of the platform.
export const resolveSiteVisitStatusName = (name) => {
  if (name === null || name === undefined || name === "")
    return siteVisitStatusEnum.default;
  const norm = String(name).toLowerCase().replace(/[^a-z]/g, "");
  for (const key of Object.keys(siteVisitStatusEnum)) {
    const t = siteVisitStatusEnum[key].text.toLowerCase().replace(/[^a-z]/g, "");
    if (t === norm) return siteVisitStatusEnum[key];
  }
  if (norm.includes("complete")) return siteVisitStatusEnum[6];
  if (norm.includes("check") || norm.includes("postdata")) return siteVisitStatusEnum[5];
  if (norm.includes("datacollection")) return siteVisitStatusEnum[4];
  if (norm.includes("preplanning")) return siteVisitStatusEnum[2];
  if (norm.includes("planning")) return siteVisitStatusEnum[3];
  return siteVisitStatusEnum.default;
};
